
import {Wing, Unit, Dependent,  DependentReservation, Room, UnoccupiedBed, Allergy, Medication} from '../constants/ProIcons'
import _ from "lodash";
import ProSetupActionMenu from '../components/setup/ProSetupActionMenu';
import ProCensusActionMenu from '../components/census/ProCensusActionMenu';
import ProClient from '../components/census/ProClient';
import { useHierarchyService } from './useHierarchyService';
import  useRolePermissionServices  from './useRolePermissionServices';
import ProClientAttendance from '../components/attendance/ProClientAttendance';


let templateData = {data: {}, actions: {}}
const useTreeTemplateServices = ({performAction})=>{  
    
    const {actions:{SetSelectedTreeNode}} = useHierarchyService();   
    const iconFontSize = 15;
    const {data:{AttendanceRoles}} = useRolePermissionServices();
   
//#region GENERIC
const TreeNodeTemplate = (node, column)=> {       
    let colValue;
    switch(node.type){
        case "LOCATION":
            colValue =  <i className ="fas fa-map-marker-alt" aria-hidden="true" style={{ color: '#384C7E', fontSize: iconFontSize }}>               
                <span className='tree-node-location '>{node.data.name}                   
                </span>
                </i>    
            break;
        case "BUILDING":
            colValue =  <i className ="fas fa-home-lg-alt" aria-hidden="true" style={{ color: '#384C7E', fontSize: iconFontSize}}>               
                <span className='tree-node' >{node.data.name}
                    {!_.get(node, "active") && <span  style={{ fontSize: 11,color:"#808080" }}> - Inactive</span> }
                </span>
                </i>    
            break;
        case "FLOOR":
            colValue =  <i className ="fas fa-layer-group" aria-hidden="true" style={{ color: '#384C7E', fontSize: iconFontSize }}>               
                <span className='tree-node'>{node.data.name}
                    {!_.get(node, "active") && <span  style={{ fontSize: 11,color:"#808080" }}> - Inactive</span> }   
                </span>
                </i>    
        
            break;  
        case "UNIT":
            colValue = <i className ="fas" aria-hidden="true" style={{ color: '#384C7E', fontSize: iconFontSize, top: "3px" }}>
                  <div className='icon-display'>
                  <div><Unit/></div>
                    <span className='tree-node'>{node.data.name}
                        {!_.get(node, "active") && <span  style={{ fontSize: 11,color:"#808080", position: 'relative' }}> - Inactive</span> }
                    </span>
                </div>
            </i>    
            break;
        case "WING":
            colValue = <i className ="fas" aria-hidden="true" style={{ color:  '#384C7E', fontSize: iconFontSize,  top: "3px" }}>
                <div className='icon-display'>
                    <div><Wing/></div>
                    <span className='tree-node'>{node.data.name}
                        {!_.get(node, "active") && <span  style={{ fontSize: 11,color:"#808080"}}> - Inactive</span> }
                    </span>
                </div>
            </i> 
            break;           
        case "ROOM":
            colValue =  <i className ="fas" aria-hidden="true" style={{ color: '#384C7E', fontSize: iconFontSize, top: "3px"  }}>   
                           <div className='icon-display'>
                               <div><Room/> </div>            
                                <span className='tree-node'>{node.data.name}
                                    {!_.get(node, "active") && <span  style={{ fontSize: 11,color:"#808080" }}> - Inactive</span> }
                                </span>
                            </div> 
                        </i>    
            break;
        case "BED":
            var data = _.get(node.data, "assignments")?_.filter(node.data.assignments, (a)=> a.latestAssignment): null;
            if (!(_.isNull(data) || (_.get(data, "length") === 0)) && (data &&_.isEqual(data[0].occupancyStatus, "OCCUPIED")))
            {  
                colValue =  <i className ="fas fa-bed" aria-hidden="true" style={{ color: '#579800', fontSize: iconFontSize }}>               
                        <span className='tree-node'>{node.label}
                        {!_.get(node, "active") && <span  style={{ fontSize: 11,color:"#808080" }}> - Inactive</span> }</span>
                        </i>  
            }else{
                colValue =  <i className ="fas" aria-hidden="true" style={{ color: '#579800', fontSize: iconFontSize }}>   
                           <div className='icon-display'>
                               <div><UnoccupiedBed/> </div>            
                                <span className='tree-node'>{node.data.name}
                                    {!_.get(node, "active") && <span  style={{ fontSize: 11,color:"#808080" }}> - Inactive</span> }
                                </span>
                            </div> 
                        </i>    
            }          
            break;
        default:
            colValue = <i className ="fas" aria-hidden="true"><span className='tree-node'>{node.data.name}</span></i>
            break    
    }
    return colValue;  
}

const OnTreeNodeSelect = (e)=>{       
        SetSelectedTreeNode(e.node); // Set globally
}

//#endregion

//#region  SETUP 
 const SetupNodeActionTemplate = (node, column)=>{
    if(node.type !== "LOCATION")
    return <ProSetupActionMenu performAction={performAction}/>
    else{
        return <span className='tree-node' style={{position: 'relative'}}>{_.get(node.data, "action") || ""}</span>         
    }  

}

const SetupBedStatusTemplate = (node, column)=> {  
    if(node.type === "BED")
    {    const data = _.get(node.data, "assignments")?_.filter(node.data.assignments, (a)=> a.latestAssignment)[0]: node.data;   
        if(_.get(data, "occupancyStatus") === "OCCUPIED"){
            if(_.get(data.occupantType, "code") === "CLIENT"){
            return <i className ="fa fa-user" aria-hidden="true" style={{ color: '#34436d', fontSize: iconFontSize, position: 'relative' }}>               
                <span className='tree-node' style={{position: 'relative'}}>{`${data.occupancyStatus}`}</span>                
            </i> 
            }else{
                return <i className ="fas" aria-hidden="true" style={{ color: '#34436d', fontSize: iconFontSize, position: 'relative' }}> 
                <Dependent/>              
                <span className='tree-node' style={{position: 'relative', top: "-1px"}}>{`${data.occupancyStatus}`}</span>                
            </i> 
            }
        }
        else if(_.get(data, "occupancyStatus") === "UNOCCUPIED" && _.get(data, "reservationStatus") === "RESERVED")
            if(_.get(data.occupantType, "code") === "CLIENT"){
                return <i className ="fal fa-user" aria-hidden="true" style={{ color: '#34436d', fontSize: iconFontSize, position: 'relative' }}>               
                    <span className='tree-node' style={{position: 'relative'}}>{`${data.reservationStatus}`} </span>
                </i> 
            }else{
                return <i className ="fas" aria-hidden="true" style={{ color: '#34436d', fontSize: iconFontSize, position: 'relative' }}> 
                <DependentReservation/>              
                <span className='tree-node' style={{position: 'relative', top: "-1px"}}>{`${data.reservationStatus}`} </span>
            </i> 
            }
        else
         return  <span className='tree-node' style={{position: 'relative'}}> </span>
       
    }   
}

const SetupTableConfig = [{field: "name", actionTemplate:TreeNodeTemplate, expander: true, style:{}}
                         ,{field: "currentStatus", actionTemplate:SetupBedStatusTemplate, expander: false, style:{textAlign:"left", width:"200px"}}
                         ,{field: "action", actionTemplate:SetupNodeActionTemplate, expander: false, style:{textAlign:"right"}}]

//#endregion

//#region CENSUS
 const CensusClientTemplate = (node, column)=> {  
    if(node.type === "BED" && _.get(node.data, "assignments"))
            return <div>
                {node.data.assignments.map((assignment, index)=>{
                   return <ProClient key={index} data={assignment}/>                 
               })} 
            </div> 
 }

const  CensusBedActionTemplate = (node, column)=> {  
    if(node.type === "BED" && _.get(node, "active")){        
        if(_.get(node.data, "assignments")){
            const activeAssignment = _.find(node.data.assignments, function(o) { return o.latestAssignment; })
            return  <div>
                        {_.isEmpty(activeAssignment) && <ProCensusActionMenu  performAction={performAction}/> }
                        {node.data.assignments.map((assignment, index)=>{
                        return  <ProCensusActionMenu key={index}  data={assignment}  performAction={performAction}/>               
                    })} 
                </div> 
        }
        else{
            return  <ProCensusActionMenu  performAction={performAction}/> 
        }
    }
   
    else{        
        return <span className='tree-node'>{_.get(node.data, "action")  || ""}</span>         
    }  
}

const  ClientHasClientAllergy = (node, column)=> {  
    if(_.get(node.data, "assignments")){
        return  <div>
                {node.data.assignments.map((assignment, index)=>{
                    if(_.get(assignment.occupantType, "code") === "CLIENT" && _.get(assignment.client, "hasClientAllergy")){
                        return  <div key={index} className='tree-node'>
                            <i className ="fas" aria-hidden="true"    style={{ color: 'green', fontSize: 14, position: 'relative' }}>
                                <Allergy/>
                            </i>
                        </div> 
                    }else {
                        return <div key={index} className='tree-node'></div>
                    }               
                })} 
            </div> 
    }
}
const  ClientHasClientMedications = (node, column)=> {     
    if(_.get(node.data, "assignments")){
        return  <div>
                {node.data.assignments.map((assignment, index)=>{
                    if(_.get(assignment.occupantType, "code") === "CLIENT" && _.get(assignment.client, "hasClientMedications")){
                        return  <div key={index} className='tree-node'>
                            <i className ="fas" aria-hidden="true"    style={{ color: 'red', fontSize: 14, position: 'relative' }}>
                                <Medication/>
                            </i>
                        </div> 
                    }else {
                        return <div key={index} className='tree-node'></div>
                    }               
                })} 
            </div>         
    }  
}


const CensusTableConfig = [{field: "name", actionTemplate:TreeNodeTemplate, expander: true, style:{}}
                          ,{field: "hasClientMedications", actionTemplate:ClientHasClientMedications, expander: false, style:{textAlign:"center", width:"30px"}}
                          ,{field: "hasClientAllergy", actionTemplate:ClientHasClientAllergy, expander: false, style:{textAlign:"center", width:"30px"}}
                          ,{field: "clientDisplayName", actionTemplate:CensusClientTemplate, expander: false, style:{textAlign:"left"}}
                          ,{field: "action", actionTemplate:CensusBedActionTemplate, expander: false, style:{textAlign:"right"}}]



//#endregion

//#region Attendance
const AttendanceClientTemplate = (node, column)=> {  
    if(node.type === "BED" && _.get(node.data, "assignments"))
            return <div>
                {node.data.assignments.map((assignment, index)=>{
                   return <ProClient key={index} data={assignment}/>                 
               })} 
            </div> 
 }

 
const AttendanceNodeActionTemplate = (node, column)=>{    
    if(node.type === "BED" && _.get(node.data, "assignments") 
        && _.get(node.data.assignments, "length") > 0 && node.data.assignments[0].occupancyStatus === "OCCUPIED"
        && _.get(node.data.assignments[0].occupantType, "code") === "CLIENT" && AttendanceRoles.canMarkAttendance) 
    { 
       return <ProClientAttendance bed={node}/>
    }

    return <span className='tree-node'>{_.get(node.data, "action")  || ""}</span> 

}

const AttendanceTableConfig = [{field: "name", actionTemplate:TreeNodeTemplate, expander: true}
                         ,{field: "clientDisplayName", actionTemplate:AttendanceClientTemplate, expander: false, style:{textAlign:"left"}}
                         ,{field: "action", actionTemplate:AttendanceNodeActionTemplate, expander: false, style:{textAlign:"right"}}]
//#endregion
    templateData = {data: {SetupTableConfig, CensusTableConfig, AttendanceTableConfig}, actions:{ OnTreeNodeSelect}}

   
    return templateData
}

export default useTreeTemplateServices 